// src/store/productCategoryManagment/actions.ts

import { ProductCategory } from '../../dataTypes/productManagment/types';

import {
  FETCH_PRODUCT_CATEGORY_REQUEST,
  FETCH_PRODUCT_CATEGORY_SUCCESS,
  FETCH_PRODUCT_CATEGORY_FAILURE,
  ProductCategoryActionTypes
} from './types';

import { Dispatch } from 'redux';
import { RootState } from '../generalReducer';
import { store } from '../store';

import { getProductCategories } from '../../backendServices/productManagment/api_productCategory';

export const fetchProductCategories = (renew: boolean = false, adminId?: number) => async (dispatch: Dispatch<ProductCategoryActionTypes>, getState: () => RootState) => {
  const state = getState();
  const lastFetched = state.productCategoryReducer.lastFetchTimestamp;
  const cacheDuration = 10 * 60 * 1000; // 10 minutes en millisecondes

  // Le cache n'est pas indexé par adminId : on le contourne dès qu'un filtre adminId est demandé
  if (lastFetched && Date.now() - lastFetched < cacheDuration && !renew && !adminId) {
    return;
  }

  dispatch({ type: FETCH_PRODUCT_CATEGORY_REQUEST });

  try {
    const response = await getProductCategories(adminId);

    if (response.code === 1) {
      dispatch({
        type: FETCH_PRODUCT_CATEGORY_SUCCESS,
        payload: {
          categories: response.payload,
          lastFetchTimestamp: Date.now()
        }
      });
    } else {
      dispatch({ type: FETCH_PRODUCT_CATEGORY_FAILURE, payload: response.comment });
    }
  } catch (error: unknown) {
    dispatch({ type: FETCH_PRODUCT_CATEGORY_FAILURE, payload: (error as Error).message || 'Une erreur inconnue est survenue.' });
  }
};

export const retrieveProductCategories = async (renew: boolean = false): Promise<ProductCategory[]> => {
  const { dispatch, getState } = store;
  const state = getState();
  const categories = state.productCategoryReducer.categories;

  if (categories.size > 0 && !renew) {
    return Array.from(categories.values());
  }

  await dispatch(fetchProductCategories(renew));
  const updatedState = getState();
  return Array.from(updatedState.productCategoryReducer.categories.values());
};

export const retrieveProductCategoryById = async (categoryId: number): Promise<ProductCategory | null> => {
  const { dispatch, getState } = store;
  const state = getState();
  const categories = state.productCategoryReducer.categories;

  if (categories.has(categoryId)) {
    return categories.get(categoryId) ?? null;
  }

  await dispatch(fetchProductCategories());
  const updatedState = getState();
  return updatedState.productCategoryReducer.categories.get(categoryId) ?? null;
};